import React, { Component } from "react";
import styled from "styled-components";
import Aux from "../../hoc/Aux";
import Modal from "../../UI/Modal/Modal";

import Button from "@material-ui/core/Button";
//import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";

import { Icon } from "react-icons-kit";
import { ic_lock_outline } from "react-icons-kit/md/ic_lock_outline";

import {
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock
} from "react-bootstrap";

import firebase from "../../firebase/firebase";

const NewsletterButton = styled(Button)`
  &&& {
    margin-right: 6rem;
    text-transform: uppercase;
    color: ${props => props.theme.colorPrimary};
    font-weight: 600;
    font-size: 17px;
    padding: 0;

    @media (max-width: 700px) {
      font-size: 14px;
      font-weight: 400;
      align-self: baseline;
      justify-items: center;
      margin-right: 0;
    }
  }
`;

const ComponentContainer = styled.div`
  @media (max-width: 700px) {
    //text-align: end;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem;
`;

const Title = styled.div`
  font-size: 19pt;

  @media (max-width: 600px) {
    font-size: 17pt;
  }
`;

const PrivacyText = styled(HelpBlock)`
  &&& {
    font-size: 7pt;
    font-style: italic;

    @media (600px) {
      font-size: 5pt;
    }
  }
`;

const StyledLabel = styled(ControlLabel)`
  &&& {
    @media (max-width: 600px) {
      font-size: 11px;
      text-align: center;
    }
  }
`;

const StyledBlock = styled(FormControlLabel)`
  &&& {
    font-size: 11px;
  }
`;

class Newsletter extends Component {
  state = {
    modalShow: false,
    value: "",
    email: "",
    check: false
  };

  updateInput = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  closeHandler = () => {
    this.setState({ modalShow: false });
  };

  openHandler = () => {
    this.setState({ modalShow: true });
  };

  addEmail = e => {
    e.preventDefault();
    const database = firebase.database();
    database.ref("Subscriptions").push({ email: this.state.email });
    this.setState({
      email: ""
    });
  };

  render() {
    return (
      <Aux>
        <ComponentContainer>
          <NewsletterButton onClick={this.openHandler}>
            Newsletter
          </NewsletterButton>
          <Modal show={this.state.modalShow} modalClosed={this.closeHandler}>
            <Container>
              <Title>Join Our Newsletter</Title>
              <FormGroup controlId="formEmail" onSubmit={this.addEmail}>
                <StyledLabel>
                  Get the latest updates about SAMPELL and our progress
                </StyledLabel>
                <div>
                  <FormControl
                    type="email"
                    name="email"
                    value={this.state.email}
                    placeholder="Enter Your Email"
                    onChange={this.updateInput}
                  />
                </div>
                <HelpBlock>
                  <StyledBlock
                    control={
                      <Checkbox
                        icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                        checkedIcon={<CheckBoxIcon fontSize="small" />}
                        value="checkedI"
                      />
                    }
                    label="Yes, I would like to receive communications by email"
                  />
                </HelpBlock>
                <PrivacyText>
                  <Icon size={10} icon={ic_lock_outline} />
                  Your email address is 100% secure from spam
                  <a href="/privacy"> (Privacy Policy)</a>
                </PrivacyText>
              </FormGroup>
            </Container>
          </Modal>
        </ComponentContainer>
      </Aux>
    );
  }
}

export default Newsletter;



// WEBPACK FOOTER //
// ./src/components/Newsletter/Newsletter.js